import { Component, inject, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxButtonComponent,
    DxDataGridComponent,
    DxDataGridModule,
    DxFormComponent,
    DxFormModule,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import { AccessType, AuthService, GlCodeClientGridViewDto, PermissionType } from '@services';
import { FilterPanelComponent } from '../../../../components/library/filter-panel/filter-panel.component';
import {
    FilterConfig,
    GridPageComponent,
} from '../../../common/grid-page.component';

@Component({
    selector: 'app-gl-code-clients',
    imports: [
        CommonModule,
        DxDataGridComponent,
        DxiColumnComponent,
        DxoHeaderFilterComponent,
        DxoScrollingComponent,
        DxButtonComponent,
        DxiItemComponent,
        DxDataGridModule,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoFilterRowComponent,
        DxFormComponent,
        FilterPanelComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSelectionComponent,
        DxFormModule,
    ],
    templateUrl: './gl-code-clients.component.html',
})
export class GlCodeClientsComponent extends GridPageComponent<GlCodeClientGridViewDto> {
    @ViewChild(DxDataGridComponent, { static: false }) grid!: DxDataGridComponent;
    @Input() offset: number = 100;

    private authService = inject(AuthService);

    protected override exportName: string = 'GL Code Sites Report';

    dataSource = this.dataSources.glCodeClients();

    protected override filterConfig: FilterConfig[] = [
        { field: 'name', op: 'contains' },
        { field: 'department', op: 'contains' },
        { field: 'province', op: 'contains' },
        { field: 'address', op: 'contains' },
        { field: 'city', op: 'contains' },
        { field: 'postalCode', op: 'contains' },
        { field: 'phoneNumber', op: 'contains' },
    ];

    public provinceOptions = [
        { text: 'Ontario', value: 'Ontario' },
        { text: 'Alberta', value: 'Alberta' },
    ];

    constructor() {
        super();
        this.init(GlCodeClientGridViewDto);
    }

    addNew() {
        this.grid.instance.addRow();
    }

    onRowUpdating(e: any) {
        e.newData = Object.assign({}, e.oldData, e.newData);
    }

    onRowDblClick(e: any) {
        if (e.rowType === 'data' && this.canManage) {
            e.component.editRow(e.rowIndex);
        }
    }
    
    get canManage() {
        return this.authService.checkPermission(PermissionType.GlCodesClients, AccessType.Manage);
    }
}